<template>
  <div class="book-hero">
    <div class="book-hero__card">
      <BookCover :doc="doc" />
    </div>
    <div class="book-hero__text">
      <h2 class="book-hero__category">{{ title }}</h2>
      <h1 class="book-hero__name">{{ doc.title }}</h1>
      <div v-if="showHighlightsInfo" class="book-hero__highlights">
        <span class="book-hero__highlights-link"
          ><span class="book-hero__highlights-icon iconfont ihighlights" />{{
            highlightsCount
          }}</span
        >
        <span class="book-hero__highlights-link"
          ><span class="book-hero__highlights-icon iconfont inotes" />{{
            notesCount
          }}</span
        >
        <span v-if="bookmarks.length > 0" class="book-hero__highlights-link"
          ><span class="book-hero__highlights-icon iconfont iflag" />{{
            bookmarksCount
          }}</span
        >
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { DocView } from '@/models/doc'

import BookCover from '@/app/components/book/card/BookCover.vue'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    doc: DocView
    title: string
    showHighlightsInfo?: boolean
  }>(),
  {
    showHighlightsInfo: true,
  },
)

const highlights = computed(() => {
  return props.doc.highlights.filter((h) => h.highlight_type !== 'bookmark')
})

const bookmarks = computed(() => {
  return props.doc.highlights.filter((h) => h.highlight_type === 'bookmark')
})

function getsCountText(count: number, text: string): string {
  switch (count) {
    case 0:
      return `No ${text}s`
    case 1:
      return `1 ${text}`
  }
  return `${count} ${text}s`
}

const highlightsCount = computed(() => {
  return getsCountText(highlights.value.length, 'Highlight')
})

const notesCount = computed(() => {
  return getsCountText(highlights.value.filter((h) => h.text).length, 'Note')
})

const bookmarksCount = computed(() => {
  return getsCountText(bookmarks.value.length, 'Bookmark')
})
</script>
